module.exports = __webpack_public_path__ + "img/checklist_ger.43c3eb97.png";